import { useQuery } from 'react-query';

import getInvoices from '@/common/api/invoices/getInvoices';
import { ENDPOINT_INVOICES } from '@/common/constants';

const useInvoices = (number, keepPreviousData = true) =>
  useQuery([ENDPOINT_INVOICES, number], getInvoices, {
    enabled: !!number,
    keepPreviousData,
  });

export default useInvoices;
